// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_es-0";
export var fileCarousel = "_es-2";
export var removeFileButton = "_es-1";